import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { SHOP_URL } from "../lib/assets";
import CartridgeGX4000 from "./CartridgeGX4000";

export const SpecsSection = () => {
  const { t } = useI18n();
  return (
    <section
      id="specs"
      data-testid="specs-section"
      className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 md:py-28"
    >
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        {/* Cartridge */}
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="section-tag">{t.cartridge.title}</div>
          <h2 className="font-pixel text-[#ffe600] glow-yellow text-4xl sm:text-5xl mt-2 tracking-widest">
            {t.cartridge.title}
          </h2>
          <p className="font-mono text-sm text-[#94a3b8] mt-4 leading-relaxed max-w-md">
            {t.cartridge.desc}
          </p>

          <div className="mt-6">
            <a
              data-testid="specs-shop-link"
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-retro"
            >
              ▶ {t.hero.preorder}
            </a>
          </div>
        </div>

        <div className="lg:col-span-3 order-1 lg:order-2 relative">
          <CartridgeGX4000
            data-testid="cartridge-image"
            className="mx-auto w-full max-w-[260px]"
          />
        </div>

        {/* Boot terminal */}
        <div className="lg:col-span-4 order-3">
          <div className="section-tag">{t.specs.title}</div>
          <h3 className="font-pixel text-[#2bff88] glow-green text-3xl sm:text-4xl mt-2 tracking-widest">
            {t.specs.title}
          </h3>
          <div className="mt-5 terminal-frame">
            <pre className="font-pixel text-[#2bff88] glow-green text-lg leading-7 px-4 py-4 m-0 whitespace-pre-wrap">
{t.specs.lines.join("\n")}
              <span className="blink">_</span>
            </pre>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecsSection;
